import initialState from './initialState'

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case 'UPDATE_ENVIRONMENT':
      return action.environment
    default:
      return state
  }
}

export default reducer
